<template>
  <div class="">
    <el-radio-group v-model="localValue.type" size="mini">
      <el-radio-button label="vip">会员</el-radio-button>
      <el-radio-button label="noVip">非会员</el-radio-button>
    </el-radio-group>
    <el-radio-group v-if="showDisplayMode" v-model="localValue.vip.displayMode" size="mini">
      <el-radio-button :label="memberBenefitMode">显示会员已有优惠券及积分</el-radio-button>
      <el-radio-button :label="hotZoneMode">设置热区</el-radio-button>
    </el-radio-group>
    <CompHotSetting
      v-if="showHotSetting"
      v-model='localValue[localValue.type]'
      :uuid="`${uuid}_${localValue.type}`"
      :visible="localValue.type=='noVip'"/>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import CompHotSetting from "../../comps/comp_hotSetting";

const HOT_ZONE_MODE = 'hotZone'
const MEMBER_BENEFIT_MODE = 'memberBenefit'

export default {
  components: {
    CompHotSetting
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          type: 'vip',
          vip: {
            imgUrl: "", data: [], displayMode: HOT_ZONE_MODE
          },
          noVip: {
            imgUrl: "", data: []
          }
        }
      }
    },
    uuid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      localValue: {
        type: 'vip',
        vip: {
          imgUrl: "", data: [], imgName: '', displayMode: HOT_ZONE_MODE
        },
        noVip: {
          imgUrl: "", data: [], imgName: ''
        }
      },
      hotZoneMode: HOT_ZONE_MODE,
      memberBenefitMode: MEMBER_BENEFIT_MODE
    }
  },
  computed: {
    showDisplayMode() {
      return this.localValue.type == 'vip'
    },
    showHotSetting() {
      return this.localValue.type != 'vip' || (this.localValue.vip.displayMode || HOT_ZONE_MODE) === HOT_ZONE_MODE
    }
  },
  watch: {
    uuid: {
      handler() {
        this.localValue = this.normalizeValue(this.value)
      },
      immediate: true
    },
    localValue: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true
    },
  },
  methods: {
    normalizeValue(value) {
      const localValue = cloneDeep(value || {})
      return {
        ...localValue,
        type: localValue.type || 'vip',
        vip: {
          imgUrl: "",
          data: [],
          imgName: '',
          displayMode: HOT_ZONE_MODE,
          ...(localValue.vip || {})
        },
        noVip: {
          imgUrl: "",
          data: [],
          imgName: '',
          ...(localValue.noVip || {})
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-radio-group,
.el-input {
  margin-bottom: 10px;
}

</style>